import { render, staticRenderFns } from "./CaixaVeiculoFormCarga.vue?vue&type=template&id=3aed039b&"
import script from "./CaixaVeiculoFormCarga.vue?vue&type=script&lang=js&"
export * from "./CaixaVeiculoFormCarga.vue?vue&type=script&lang=js&"
import style0 from "./CaixaVeiculoFormCarga.vue?vue&type=style&index=0&id=3aed039b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports